<template>
  <v-card class="ma-2">
    <v-toolbar dense>
      <v-toolbar-title>Equivalência de Planos - Prestadores</v-toolbar-title>
      <v-spacer />
      <v-btn small @click="$router.push(`/equivalence_configuration/${$route.params.keyId}/details`)">
        <v-icon small title="Fechar">fas fa-arrow-circle-left</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card tile class="pa-4">
      <div v-if="equivConf">
        <v-card-title>Dados Principais</v-card-title>

        <!-- Seleção de REGIÃO -->
        <v-row v-if="equivConf" align-content="stretch" dense align="start">
          <v-col cols="3">
            <ApiSelect
              label="Região"
              :service="(p) => productNetworkService.getRegionsByPlan(p)"
              :serviceParams="equivConf.referencePlan.id"
              :labelProvider="(item) => item.name"
              itemValue="id"
              :highlights="configuredRegions"
              @select="onSelectRegion"
            />
          </v-col>
          <v-col cols="1">
            <v-btn
              v-if="!planOrderView.length && regionId && !loadingPlanOrderView"
              @click="onCreateOrdConf"
            >
              <v-icon small title="Fechar">fas fa-plus</v-icon>
              &nbsp;Gerar Classificação
            </v-btn>
          </v-col>
        </v-row>

        <!-- Seleção de OPERADORA -->
        <v-row
          align-content="stretch"
          align="center"
          dense
          v-if="equivConf.referencePlan"
        >
          <v-col cols="3">
            Operadora Referência<br />{{ equivConf.referencePlan.carrierName }}
          </v-col>

          <v-col cols="2" v-for="index in 4" :key="index">
            <v-select
              dense
              outlined
              :items="carrierList"
              itemValue="id"
              item-text="name"
              label="Operadora Equivalente"
              clearable
              v-model="plans[index - 1].carrierId"
              @change="selectCarrier(index, $event)"
              :disabled="hideSelectsPlan"
            />
          </v-col>
        </v-row>

        <!-- Seleção de PLANO -->
        <v-row
          align-content="stretch"
          align="center"
          dense
          v-if="equivConf.referencePlan"
        >
          <v-col cols="3">
            Plano Referência<br />
            {{
              equivConf.referencePlan
                ? `${equivConf.referencePlan.productCode}-${equivConf.referencePlan.description}`
                : 'Carregando...'
            }}
          </v-col>
          <v-col cols="2" v-for="index in 4" :key="index">
            <v-select
              dense
              outlined
              :items="plans[index - 1].items"
              itemValue="id"
              :item-text="
                (i) =>
                  `${plansConfigured[i.id] ? '#' : ''} ${i.productCode} - ${
                    i.description
                  }`
              "
              label="Plano Equivalente"
              clearable
              v-model="plans[index - 1].planId"
              :disabled="
                plans[index - 1].loading || !plans[index - 1].carrierId
              "
              :loading="plans[index - 1].loading"
            >
            </v-select>
          </v-col>
        </v-row>
        <!-- Opções de CONGIGURAÇÃO OPERADORA -->
        <v-row dense>
          <v-col cols="3" />
          <v-col cols="2" v-for="index in 4" :key="index">
            <v-btn
              v-if="
                planOrderView.length &&
                plans[index - 1].planId &&
                !plansConfigured[plans[index - 1].planId]
              "
              @click="onCreateOrdPlan(plans[index - 1].planId)"
              x-small
            >
              <v-icon x-small title="Fechar">fas fa-plus</v-icon>
              &nbsp;Gerar Configuração
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="loadingPlanOrderView"
          align-content="stretch"
          align="center"
          dense
        >
          <!-- Table matriz de configuração -->
          <v-progress-linear indeterminate />
        </v-row>

        <div v-if="planOrderView.length > 0 && !loadingPlanOrderView">
          <v-row dense v-for="nindex in planOrderView.length" :key="nindex">
            <v-card width="100%">
              <v-card-title>{{ titles[nindex - 1] }}</v-card-title>
              <span style="display:none">{{nhack}}</span>

              <!-- Controle de exibição -->
              <div class="d-flex mb-3 mx-3">
                <v-btn
                  @click="
                    displayOpts[nindex - 1].showLinenumber =
                      !displayOpts[nindex - 1].showLinenumber
                  "
                  x-small
                  plain
                >
                  <v-icon x-small>
                    fas
                    {{
                      displayOpts[nindex - 1].showLinenumber
                        ? 'fa-chevron-left'
                        : 'fa-chevron-right'
                    }}
                  </v-icon>
                </v-btn>
                <v-btn
                  class="ml-auto"
                  @click="
                    displayOpts[nindex - 1].showHiddens =
                      !displayOpts[nindex - 1].showHiddens
                  "
                  x-small
                  plain
                >
                  <v-icon x-small>
                    fas
                    {{
                      displayOpts[nindex - 1].showHiddens
                        ? 'fa-chevron-down'
                        : 'fa-chevron-up'
                    }}
                  </v-icon>
                </v-btn>
              </div>

              <draggable
                :list="planOrderView[nindex - 1].items"
                ghost-class="ghost"
                @end="onMoveCallback(nindex, $event)"
              >
                <div
                  class="mx-2"
                  v-for="(line, index) in planOrderView[nindex - 1].items"
                  :key="index"
                >
                  <v-row
                    dense
                    v-if="
                      displayOpts[nindex - 1].showHiddens || !isHiddenLine(line)
                    "
                    class="my-1 line-item"
                    align="center"
                  >
                    <v-col cols="3">
                      <span class="ord1">
                        {{ String(index + 1).padStart(2, '0') }}
                      </span>
                      -
                      <span
                        v-if="displayOpts[nindex - 1].showLinenumber"
                        class="ord2"
                      >
                        {{
                          line.lineNumber != ''
                            ? String(line.lineNumber).padStart(2, '0')
                            : '&nbsp;&nbsp;&nbsp;&nbsp;'
                        }}
                      </span>

                      <f-checkbox
                        :label="line.providerName"
                        :value="line.hide"
                        :hidden="isHiddenLine(line)"
                        :onClick="() => onHideProvider(line)"
                      />
                    </v-col>

                    <v-col cols="2" v-for="index in 4" :key="index">
                      <f-checkbox
                        v-if="
                          plans[index - 1].planId &&
                          line.planEquivs[plans[index - 1].planId]
                        "
                        :label="line.providerName"
                        :value="
                          line.planEquivs[plans[index - 1].planId]
                            .hideEquivalentProvider
                        "
                        :hidden="isHiddenLine(line)"
                        :onClick="
                          () =>
                            onHideEquivalentProvider(
                              line.planEquivs[plans[index - 1].planId],
                            )
                        "
                      />
                    </v-col>

                    <v-col cols="1">
                      <v-text-field
                        :ref="`npos-${index}`"
                        dense
                        single-line
                        flat
                        class="small-input"
                        append-outer-icon="fas fa-share"
                        type="number"
                        min="1"
                        :max="planOrderView[nindex - 1].items.length"
                        @click:append-outer="onClickOrder(nindex, index)"
                      />
                    </v-col>
                  </v-row>
                </div>
              </draggable>
            </v-card>
            &nbsp;
          </v-row>
        </div>
       
      </div>

      <div v-if="!equivConf">
        <div v-if="!error">
          <v-row>
            <v-col offset="5"> Carregando ... </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-progress-linear indeterminate />
            </v-col>
          </v-row>
        </div>
        <div v-if="error">
          <v-row>
            <v-col>
              <v-alert dense outlined prominent text type="error">
                {{ error }}
              </v-alert>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
  </v-card>
</template>

<script>
import Vue from 'vue';
import {mapMutations} from 'vuex';
import ApiSelect from '@/components/api-select.vue';
import draggable from 'vuedraggable';

import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';
import ProductNetworkService from '@/services/odoo/ProductNetworkService';
import ProductService from '@/services/odoo/ProductService';

import FCheckbox from './components/f-checkbox.vue';

export default {
  components: {ApiSelect, draggable, FCheckbox},
  data() {
    return {
      equivConf: null,
      planOrderView: [],
      loadingPlanOrderView: false,
      regionId: null,
      configuredRegions: [],
      plans: [
        {carrierId: null, planId: null, items: [], loading: false},
        {carrierId: null, planId: null, items: [], loading: false},
        {carrierId: null, planId: null, items: [], loading: false},
        {carrierId: null, planId: null, items: [], loading: false},
      ],
      displayOpts: [
        {showHiddens: true, showLinenumber: true},
        {showHiddens: true, showLinenumber: true},
      ],
      error: null,
      plansConfigured: {},
      titles: ['Hospitais', 'Laboratórios'],
      nhack: 0,
    };
  },

  methods: {
    ...mapMutations(['toogleDialogLoading']),

    async selectCarrier(index, carrierId) {
      if (!carrierId) {
        this.plans[index - 1].carrierId = null;
        this.plans[index - 1].planId = null;
        this.plans[index - 1].items = [];
        this.plans[index - 1].loading = false;
        return;
      }
      this.plans[index - 1].carrierId = carrierId;
      this.plans[index - 1].planId = null;
      this.plans[index - 1].items = [];
      this.plans[index - 1].loading = true;

      try {
        const response = await this.equivConfService.findPlansByCarrier(
          this.equivConf.id,
          carrierId,
          this.regionId
        );

        this.plans[index - 1].items = response.data;
        this.plans[index - 1].loading = false;
      } catch (error) {
      } finally {
      }
    },

    async _updatePlanOrderView(nindex) {
      this.toogleDialogLoading(true);

      const pocList = this.planOrderView[nindex - 1].items.map((item) => {
        return {
          id: item.provOrdConfId,
          order: item.order,
          hideReferenceProvider: item.hide,
        };
      });

      try {
        await this.equivConfService.updateProviderOrderConfiguration(
          this.equivConf.id,
          this.planOrderView[nindex - 1].ordConfId,
          pocList,
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.nhack++;
        this.toogleDialogLoading(false);
      }
    },

    async onMoveCallback(nindex, evt) {
      this.calculeLineNumber();
      this.planOrderView[nindex - 1].items.forEach(
        (item, index) => (item.order = index + 1),
      );
      await this._updatePlanOrderView(nindex);
    },

    async onClickOrder(nindex, index) {
      let origin = this.$refs[`npos-${index}`][0].$refs.input;
      const value = parseInt(origin.value);
      origin.value = '';
      if (!value || value == NaN) return;

      let items = this.planOrderView[nindex - 1].items;
      items.forEach((item, index) => (item.order = index + 1));      
      items[index].order =  items[index].order > value ? value-0.5 : value + 0.5;
      items.sort((a, b) => a.order - b.order);
      items.forEach((item, index) => (item.order = index + 1));
      this.calculeLineNumber();
      this._updatePlanOrderView(nindex);
      
    },

    async onHideEquivalentProvider(value) {
      value.hideEquivalentProvider = !value.hideEquivalentProvider;
      this.calculeLineNumber();
      try {
        await this.equivConfService.updateHideProviderExibitionConfiguration(
          this.equivConf.id,
          value.provExibConfId,
          value.hideEquivalentProvider,
        );
      } catch (error) {
        console.log(error);
      } finally {
      }
    },

    async onHideProvider(value) {
      value.hide = !value.hide;
      try {
        await this.equivConfService.updateHideProviderOrderConfiguration(
          this.equivConf.id,
          value.provOrdConfId,
          value.hide,
        );
      } catch (error) {
        console.log(error);
      } finally {
      }
    },

    _loadPlanOrderView(planOrderView) {
      planOrderView.forEach((el) => el.items.sort((a, b) => a.order - b.order));
      this.planOrderView = planOrderView;
      this.calculeLineNumber();

      this.plansConfigured = {};
      this.planOrderView.forEach((e) =>
        e.items.forEach((f) =>
          Object.keys(f.planEquivs).forEach(
            (k) => (this.plansConfigured[k] = true),
          ),
        ),
      );
    },

    async onSelectRegion(value) {
      if (!value) {
        this.regionId = value;
        this._loadPlanOrderView([]);
        this.plans = [
          {carrierId: null, planId: null, items: [], loading: false},
          {carrierId: null, planId: null, items: [], loading: false},
          {carrierId: null, planId: null, items: [], loading: false},
          {carrierId: null, planId: null, items: [], loading: false},
        ];
        return;
      }

      try {
        this.loadingPlanOrderView = true;
        const response =
          await this.equivConfService.findOrderConfigurationByParams(
            this.equivConf.id,
            {
              regionId: value,
            },
          );
        this._loadPlanOrderView(response.data);
        this.regionId = value;
      } catch (error) {
        console.log(error);
        this.error = error;
      } finally {
        this.loadingPlanOrderView = false;
      }
    },

    async onCreateOrdConf() {
      this.toogleDialogLoading(true);
      try {
        const response = await this.equivConfService.createOrderConfiguration(
          this.equivConf.id,
          {regionId: this.regionId},
        );
        this.configuredRegions.push(this.regionId);
        await this.onSelectRegion(this.regionId);
      } catch (error) {
        console.log(error);
        this.error = error;
      } finally {
        this.toogleDialogLoading(false);
      }
    },

    async _findSuperAccreditedNetworkById(planId) {
      const response = await this.productService.findSuperAccreditedNetworkById(
        planId,
      );
      return response.data.id;
    },

    async onCreateOrdPlan(selPlanId) {
      this.toogleDialogLoading(true);
      try {
        //planOrderView.length &&
        //plans[index - 1].planId &&
        //!plansConfigured[plans[index - 1].planId
        
        const parentPlanId = await this._findSuperAccreditedNetworkById(selPlanId);

        const response =
          await this.equivConfService.createPlanOrderEquivalenceConfiguration(
            this.equivConf.id,
            {
              regionId: this.regionId,
              planId: selPlanId,
              parentPlanId: parentPlanId,
            },
          );
        
        this._loadPlanOrderView(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        this.toogleDialogLoading(false);
      }
    },

    calculeLineNumber() {
      this.planOrderView.forEach((pov) => {
        let lineNumber = 1;
        pov.items.forEach((line) => {
          if (!this.isHiddenLine(line)) {
            line.lineNumber = lineNumber;
            lineNumber++;
          } else {
            line.lineNumber = '';
          }
        });
      });
    },
    /**
     * Testa se todas as operadoras desta linha estão marcadas como escondidas
     */
    isHiddenLine(line) {
      let result = true;
      for (let k in line.planEquivs) {
        result &= line.planEquivs[k].hideEquivalentProvider;
      }
      return result;
    },
  },
  computed: {
    hideSelectsPlan() {
      return this.regionId == null || this.equivConf == null;
    },
  },

  async created() {
    this.productNetworkService = new ProductNetworkService();
    this.productService = new ProductService();
    this.equivConfService = new EquivalenceConfigurationService();

    const equivConfId = this.$route.params.keyId;
    Promise.all([
      this.equivConfService.get(equivConfId),
      this.equivConfService.findCarriers(equivConfId),
    ])
      .then((responses) => {
        this.equivConf = responses[0].data;
        this.carrierList = responses[1].data;

        this.configuredRegions = this.equivConf.orderConfigurationList
          .map(e => e.regionId)
          .filter((v, i, a) => a.indexOf(v) === i);
      })
      .catch((error) => (this.error = error));
  },
};
</script>

<style scoped>
.small-input.v-text-field {
  width: 70px;
  height: 30px;
}
.ord1 {
}
.ord2 {
  color: green;
}
.ghost {
  opacity: 0.5;
  background: var(--v-border-base);
}
.line-item {
  background-color: var(--v-muted-base);
}
</style>
